import React from 'react';
import { Alert, Form, Icon, Input, Button, Row, Col } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import get from 'lodash/get';

import {resetPassword, loginTwoFactor, logout} from '../../reducers/user/actions';
import {getUserToken} from "../../reducers/user/selectors";
import { resetPasswordProfileRequest } from '../../api/requests';

import { passwordValidationRegex } from "../../utils/passwordValidationRegex";

import classes from './ResetProfileForm.css';
import { withNamespaces } from 'react-i18next';

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class ResetProfileForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      responseMessage: null,
      errorMessage: null,
      isSubmitted: false,
      checkConfirmRequestError: '',
      username: '',
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true });

      if (!err) {
        this.setState({ isLoading: true, errorMessage: null, responseMessage: null });

        try {
          await resetPasswordProfileRequest({ ...values });
          this.setState({ responseMessage: this.props.i18n.t('Success') });

          setTimeout(() => { this.props.toggleFormVisibility(); }, 1000);
        } catch (err) {
          if (get(err, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ errorMessage: get(err, 'response.data.msg', get(err, 'response.data.errors._schema[0]')), isLoading: false});
        }
      }
    });
  };


  render() {
    const { getFieldDecorator, getFieldsError } = this.props.form;
    const { isLoading, errorMessage, responseMessage, checkConfirmRequestError, username } = this.state;

    return (
      <div className={classes.loginForm}>
        <Form onSubmit={this.handleSubmit}>
          <h2>{this.props.i18n.t('Reset password')}</h2>
          {username && <p>{this.props.i18n.t('For')}: <b>{username}</b></p>}

          <div>
            <Form.Item>
              {getFieldDecorator('current_password', {
                rules: [{ required: true, message: this.props.i18n.t('Required') }]
              })(
                <Input.Password visibilityToggle prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder={this.props.i18n.t('NamespaceResetProfileForm:Current password')} />,
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator('new_password', {
                rules: [
                  { required: true, message: 'Required' },
                  {
                    pattern: passwordValidationRegex,
                    message: this.props.i18n.t('NamespaceResetProfileForm:The password must contain at least one UPPERCASE letter, one lowercase letter, one number. Password length between 8-32 characters.')
                  }
                ]
              })(
                <Input.Password visibilityToggle prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder={this.props.i18n.t('NamespaceResetProfileForm:New password')} />,
              )}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator('confirm_new_password', {
                rules: [
                  { required: true, message: 'Required' },
                ]
              })(
                <Input.Password visibilityToggle prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder={this.props.i18n.t('NamespaceResetProfileForm:Confirm new password')} />,
              )}
            </Form.Item>
          </div>

          {errorMessage && <Alert message={errorMessage} type="error" className={classes.alertsMb} />}
          {responseMessage && <Alert message={responseMessage} type="success" className={classes.alertsMb} />}
          {checkConfirmRequestError && <Alert message={checkConfirmRequestError} type="error" className={classes.alertsMb} />}

          {!responseMessage && !checkConfirmRequestError && (<Row gutter={12}>
            <Col span={12}>
              <Form.Item>
                <Button type="primary" size="large" htmlType="submit" disabled={hasErrors(getFieldsError())} className={classes.submitButton}>
                  {this.props.i18n.t('Reset password')}
                  {isLoading && <Icon type="loading" />}
                </Button>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Button size="large" htmlType="button" className={classes.submitButton} onClick={this.props.toggleFormVisibility}>
                {this.props.i18n.t('Cancel')}
              </Button>
            </Col>
          </Row>)}

        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userToken: getUserToken(state),
});

const mapDispatchToProps = {
  resetPassword,
  loginTwoFactor,
  logout,
};

export default Form.create({ name: 'login' })(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(ResetProfileForm)));



// WEBPACK FOOTER //
// ./src/components/ResetProfileForm/ResetProfileForm.js